import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { NULLISH_VALUE } from '~/common/constants';
import { PaymentTerm } from '~/common/types';

export interface PaymentTermsProps {
  items?: PaymentTerm[] | null;
}

export const PaymentTerms = ({ items }: PaymentTermsProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'PaymentTerms' });
  return (
    <>
      {items && items.length
        ? items.map((term, i) => (
            <Fragment key={i}>
              {i > 0 && <br />}
              <span>{t('combined', { daysToPayment: term.daysToPayment, discount: term.discount })}</span>
            </Fragment>
          ))
        : NULLISH_VALUE}
    </>
  );
};
